<template>
    <v-data-table
      :headers="headers"
      :items="listadoFianzas">
      <template
        v-slot:[`item.tipo`]="{ item }">
        <v-chip
          :color="item.tipoDetalle.color"
          dark>
          {{ item.tipoDetalle.nombre }}
        </v-chip>
      </template>
      <template
        v-slot:[`item.monto`]="{ item }">
        {{ item.monto | currency }}
      </template>
      <template
        v-slot:[`item.createdAt`]="{ item }">
        <fecha-humano
          :fecha="item.createdAt">
        </fecha-humano>
      </template>
      <template v-slot:[`item.acciones`]="{ item }">
      <v-tooltip
      v-if="mixValidaScopesActions(2)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="editar(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Editar</span>
      </v-tooltip>
      <v-tooltip
      v-if="mixValidaScopesActions(3)"
      top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on" @click="borrar(item)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Borrar</span>
      </v-tooltip>
    </template>
    </v-data-table>
</template>

<script>
import FechaHumano from '@/components/FechaHumano.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoListadoFianzas',
  props: {
    listadoFianzas: {
      type: Array,
      required: true,
    },
  },
  components: {
    FechaHumano,
  },
  data() {
    return {
      headers: [
        {
          text: 'Tipo',
          align: 'start',
          sortable: false,
          value: 'tipo',
        },
        { text: 'Numero', value: 'numero' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Nom. Afianzadora', value: 'nombreAfianzadora' },
        { text: 'Monto', value: 'monto' },
        // { text: 'F. Registro', value: 'createdAt' },
        {
          text: '',
          align: 'end',
          width: '150',
          value: 'acciones',
        },
      ],
    };
  },
  methods: {
    editar(fianzaContrato) {
      eventBus.$emit('editar-fianza-contrato', fianzaContrato);
    },
    borrar(fianzaContrato) {
      eventBus.$emit('eliminar-fianza-contrato', fianzaContrato);
    },
  },
};
</script>

<style lang="scss">

</style>
